export default __webpack_public_path__ + "static/media/accounts_import_template.58002445.csv";